import React, { useState } from 'react'
import { Modal, Paper, Typography, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { toastAlert } from '../../../utils/AlertContext';
import { deleteImgURL } from "../../../utils/ConstantsURL";

export const DeleteImage = ({ token, open, close, note, refresh }) => {
  const [loading, setLoading] = useState(false);
    
  const handleDeleteIndicator = async () => {
    setLoading(true);
    try {
      const response = await fetch(deleteImgURL(note.cvcapsula, note.id_sintesis), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        toastAlert("Error al eliminar la imagen", "error");
        setLoading(false);
        return;
      }

      toastAlert("Imagen eliminado correctamente", "success");
      setLoading(false);
      close();
      refresh();
    } catch (error) {
      toastAlert("Error al eliminar la imagen: " + error, "error");
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={close}>
        <Paper
            elevation={2}
            style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            outline: 'none',
            }}
        >
            <Typography variant="h6" style={{ margin: '10px 0' }}>
                ¿Estás seguro de que deseas eliminar esta imagen? Esta acción no se puede deshacer.
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <Button variant="contained" onClick={close} color="error">
                  Cancelar
              </Button>
              <LoadingButton
                variant="contained"
                color="primary"
                style={{ marginLeft: '20px' }}
                onClick={handleDeleteIndicator}
                loading={loading}
              >
                Confirmar
              </LoadingButton>
            </div>
        </Paper>
    </Modal>
  );
};
